/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect } from 'react';
import { Formik, ErrorMessage } from 'formik';
import { Link, useNavigate } from 'react-router-dom';
import {
  Autocomplete,
  Button,
  Box,
  CircularProgress,
  Grid,
  Card,
  CardMedia,
  CardActionArea,
  CardContent,
  CardHeader,
  CardActions,
  TextField,
  IconButton,
  Typography,
  FormHelperText,
  Stack
} from '@mui/material';
import Avatar from '@mui/material/Avatar';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { useDispatch, useSelector } from 'react-redux';
import ImageUploading from 'react-images-uploading';
import { ValidateSignature } from '../../../assets/validation';
import SettingAction from '../../../store/actions/SettingAction';
import globalAction from '../../../store/actions/GlobalAction';

function SignatureSettingsAdd() {
  const [images, setImages] = React.useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { addressData } = useSelector((state) => state.global);

  useEffect(() => {
    dispatch(globalAction.getAddress());
  }, [dispatch]);

  const maxNumber = 1;
  const onChange = (imageList, addUpdateIndex) => {
    console.log(addUpdateIndex, 'addUpdateIndex');
    setImages(imageList);
    // if(imageList.length > 0) {
    // setImageError("");
    // }
  };
  const onErrorChange = (errors, files) => {
    console.log(files, 'files');
    if (errors) {
      // setImages([]);
    }
  };

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper requestType">
      <div className="pageTitleWrap">
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="text" component={Link} to="/settings/signature">
            Signature Configuration
          </Typography>
          <Typography component="h2" variant="h2">
            / Add
          </Typography>
        </Stack>
      </div>
      <Formik
        initialValues={{
          name: '',
          signature: [],
          addresses: []
        }}
        validationSchema={ValidateSignature}
        // enableReinitialize
        onSubmit={(values, { setErrors, setSubmitting }) => {
          const newValues = { ...values };
          const newData = images.map((item) => item.file);
          newValues.signature = newData;
          newValues.address_ids = JSON.stringify(
            (values.addresses ?? []).map((address) => address._id)
          );
          delete newValues.addresses;
          dispatch(SettingAction.addSignature(newValues, setErrors, setSubmitting, navigate));
        }}
      >
        {({
          errors,
          touched,
          values,
          handleBlur,
          handleChange,
          handleReset,
          handleSubmit,
          isSubmitting,
          setFieldValue
        }) => (
          <form onSubmit={handleSubmit} autoComplete="off">
            <Grid container spacing={2}>
              <Grid item md={12} lg={12}>
                <Card sx={{ borderRadius: '0px' }}>
                  <CardHeader title="Signature Details" />
                  <CardContent>
                    <Grid container columnSpacing={2} rowSpacing={2}>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="name"
                          name="name"
                          label="Name"
                          variant="outlined"
                          value={values.name}
                          margin="normal"
                          // inputProps={{
                          //   maxLength: 16
                          // }}
                          onChange={handleChange}
                          onBlur={(e) => {
                            const val = (e.target.value || '').replace(/\s+/gi, ' ');
                            setFieldValue(e.target.name, val.trim());
                            handleBlur(e);
                          }}
                          error={touched.name && Boolean(errors.name)}
                          helperText={touched.name && errors.name}
                          required={false}
                          InputLabelProps={{ required: true }}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <Autocomplete
                          multiple
                          className="CurrencyField"
                          options={addressData ?? []}
                          value={values.addresses}
                          onChange={(e, newvalue) => {
                            setFieldValue('addresses', newvalue);
                          }}
                          getOptionLabel={(option) => option.address_type}
                          isOptionEqualToValue={(option, value) =>
                            option.address_type === value.address_type
                          }
                          renderOption={(props, option) => {
                            return (
                              <li {...props} key={option._id}>
                                {option.address_type}
                              </li>
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="addresses"
                              label="Office Addresses"
                              placeholder="Search Office Address"
                              variant="outlined"
                              margin="normal"
                              helperText="This signature becomes the active one for the selected addresses"
                            />
                          )}
                        />
                      </Grid>
                    </Grid>
                    <Grid container sx={{ mt: 1 }} columnSpacing={2} rowSpacing={1}>
                      <Grid item md={4} lg={4} xl={3}>
                        <ImageUploading
                          value={images}
                          onChange={onChange}
                          onError={onErrorChange}
                          maxFileSize={1048576}
                          maxNumber={maxNumber}
                          dataURLKey="data_url"
                          acceptType={['jpg', 'jpeg', 'png']}
                        >
                          {({
                            imageList,
                            onImageUpload,
                            onImageUpdate,
                            onImageRemove,
                            // isDragging,
                            dragProps,
                            errors
                          }) => (
                            <div className="upload__image-wrapper">
                              {images && images.length > 0 ? (
                                imageList.map((image, index) => {
                                  return (
                                    <Card
                                      sx={{
                                        mt: 0,
                                        width: '100%',
                                        border: '1px dashed rgba(20,20,20,0.75)'
                                      }}
                                      key={index}
                                    >
                                      <CardActionArea sx={{ position: 'relative', p: '20px' }}>
                                        <CardMedia
                                          component="img"
                                          height="100"
                                          image={image.path ? 'czxcxz' : image.data_url}
                                          alt="green iguana"
                                          onClick={() => onImageUpdate(index)}
                                        />
                                        <IconButton
                                          sx={{
                                            bgcolor: '#000 !important',
                                            color: '#fff !important',
                                            p: '4px !important',
                                            position: 'absolute',
                                            top: '15px',
                                            fontSize: '15px',
                                            right: '15px'
                                          }}
                                          className="delete_icon"
                                          onClick={() => onImageRemove(index)}
                                        >
                                          <i className="icon-close" />
                                        </IconButton>
                                      </CardActionArea>
                                    </Card>
                                  );
                                })
                              ) : (
                                <Card
                                  sx={{
                                    height: '100%',
                                    width: '100%',
                                    border: '1px dashed rgba(20,20,20,0.75)',
                                    minHeight: '100px',
                                    maxHeight: '100px',
                                    // display: 'flex',
                                    // justifyContent: 'center',
                                    // alignItems: 'center',
                                    cursor: 'pointer'
                                  }}
                                  elevation={0}
                                >
                                  <CardContent sx={{ p: '20 !important', textAlign: 'center' }}>
                                    <Box
                                      sx={{ textAlign: 'center' }}
                                      onClick={onImageUpload}
                                      {...dragProps}
                                    >
                                      <Avatar sx={{ m: '0 auto', bgcolor: 'primary.main' }}>
                                        <FileUploadIcon />
                                      </Avatar>
                                      <FormHelperText
                                        sx={{ color: 'primary.main', textAlign: 'center' }}
                                      >
                                        Upload Image
                                      </FormHelperText>
                                    </Box>
                                  </CardContent>
                                </Card>
                              )}
                              {errors ? (
                                <FormHelperText error>
                                  {errors.acceptType && (
                                    <span>
                                      Please upload one of the supported files (PNG, JPEG, JPG)
                                    </span>
                                  )}
                                  {errors.maxFileSize && (
                                    <span>The uploaded image should not exceed 1 MB</span>
                                  )}
                                  {errors.resolution && (
                                    <span>Selected file is not matching desired resolution</span>
                                  )}
                                </FormHelperText>
                              ) : (
                                ''
                              )}
                              <FormHelperText error>
                                <ErrorMessage name="signature" component="span" />
                              </FormHelperText>
                              {/* <Stack
                                className="upload__helpText"
                                direction="row"
                                spacing={2}
                                justifyContent="space-between"
                                alignItems="center">
                                <Typography variant="body1" component="p">
                                  File Size: Max 5 Mb
                                </Typography>
                                <Typography variant="body1" component="p">
                                  File Resolution: above <b>600 x 600</b> or <b>1:1</b> aspect ratio
                                </Typography>
                                <Typography variant="body1" component="p">
                                  File Format: .jpeg .jpg .png .bmp\
                                </Typography>
                              </Stack> */}
                            </div>
                          )}
                        </ImageUploading>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item lg={12} xl={12}>
                <Card sx={{ borderRadius: '0px' }}>
                  <CardActions sx={{ justifyContent: 'center', p: 3 }}>
                    <Button
                      type="submit"
                      className="save__btn"
                      variant="contained"
                      color="secondary"
                      // fullWidth
                      disabled={isSubmitting}
                      size="medium"
                    >
                      {isSubmitting ? <CircularProgress size={20} /> : 'Submit'}
                    </Button>
                    <Button
                      type="button"
                      className="cancel__btn"
                      variant="contained"
                      // fullWidth
                      color="primary"
                      size="medium"
                      onClick={() => {
                        navigate('/settings/signature');
                      }}
                    >
                      Back
                    </Button>
                    <Button
                      type="button"
                      className="cancel__btn"
                      variant="contained"
                      // fullWidth
                      color="info"
                      size="medium"
                      onClick={() => {
                        handleReset();
                        setImages([]);
                      }}
                    >
                      Clear
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </Box>
  );
}
export default SignatureSettingsAdd;
